import React, { useState } from 'react'
import { FaArrowRight } from 'react-icons/fa';
import { MdClose, MdDeliveryDining, MdLogin, MdMenu } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

const Headers = () => {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
  
    const goLogin = () => {
      setMenuOpen(false);
      navigate("/login");
    };
  
    const goRegister = () => {
      setMenuOpen(false);
      navigate("/register");
    };
  
    const goHome = () => {
      setMenuOpen(false);
      navigate("/");
    };
  
    const scrollToSection = (id) => {
      setMenuOpen(false);
  
      const element = document.getElementById(id);
  
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    };
  
  return (
    <div>
            <header className="fixed inset-x-0 top-0 z-[100]">
              <div className="mx-auto max-w-7xl px-4 pt-4 sm:px-6 lg:px-8">
                <div className="flex min-h-[74px] items-center justify-between rounded-[22px] border border-neutral-100 bg-white/95 px-4 shadow-[0_15px_50px_rgba(0,0,0,0.07)] backdrop-blur-xl sm:px-6">
                  {/* Logo */}
                  <button
                    type="button"
                    onClick={goHome}
                    className="group flex cursor-pointer items-center gap-3"
                  >
                    <div className="flex h-11 w-11 items-center justify-center rounded-[13px] bg-red-500 text-white shadow-[0_10px_25px_rgba(239,68,68,0.25)] transition duration-300 group-hover:scale-105">
                      <MdDeliveryDining className="text-[25px]" />
                    </div>
      
                    <div className="text-left">
                      <div className="text-[17px] font-black tracking-tight text-neutral-900">
                        Foodbite<span className="text-red-500">24</span>
                      </div>
      
                      <div className="text-[9px] font-bold uppercase tracking-[0.2em] text-neutral-400">
                        Rider Partner
                      </div>
                    </div>
                  </button>
      
                  {/* Desktop Navigation */}
                  <nav className="hidden items-center gap-8 lg:flex">
                    <button
                      type="button"
                      onClick={() => scrollToSection("home")}
                      className="cursor-pointer text-sm font-bold text-neutral-600 transition hover:text-red-500"
                    >
                      Home
                    </button>
      
                    <button
                      type="button"
                      onClick={() => scrollToSection("benefits")}
                      className="cursor-pointer text-sm font-bold text-neutral-600 transition hover:text-red-500"
                    >
                      Benefits
                    </button>
      
                    <button
                      type="button"
                      onClick={() => scrollToSection("how-it-works")}
                      className="cursor-pointer text-sm font-bold text-neutral-600 transition hover:text-red-500"
                    >
                      How It Works
                    </button>
      
                    <button
                      type="button"
                      onClick={() => scrollToSection("support")}
                      className="cursor-pointer text-sm font-bold text-neutral-600 transition hover:text-red-500"
                    >
                      Support
                    </button>
                  </nav>
      
                  {/* Desktop Actions */}
                  <div className="hidden items-center gap-3 lg:flex">
                    <button
                      type="button"
                      onClick={goLogin}
                      className="relative z-[101] flex min-h-[46px] cursor-pointer items-center justify-center gap-2 rounded-xl border border-neutral-200 bg-white px-5 text-sm font-bold text-neutral-700 shadow-sm transition duration-300 hover:-translate-y-0.5 hover:border-red-200 hover:bg-red-50 hover:text-red-600 active:scale-[0.98]"
                    >
                      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-red-50 text-red-500">
                        <MdLogin className="text-base" />
                      </span>
      
                      Rider Login
                    </button>
      
                    <button
                      type="button"
                      onClick={goRegister}
                      className="group relative z-[101] flex min-h-[46px] cursor-pointer items-center justify-center gap-2 rounded-xl bg-red-500 px-5 text-sm font-black text-white shadow-[0_12px_30px_rgba(239,68,68,0.25)] transition duration-300 hover:-translate-y-0.5 hover:bg-red-600 hover:shadow-[0_16px_35px_rgba(239,68,68,0.32)] active:scale-[0.98]"
                    >
                      Join as Rider
      
                      <FaArrowRight className="text-xs transition duration-300 group-hover:translate-x-1" />
                    </button>
                  </div>
      
                  {/* Mobile Menu */}
                  <button
                    type="button"
                    aria-label="Toggle menu"
                    onClick={() => setMenuOpen((prev) => !prev)}
                    className="flex h-11 w-11 cursor-pointer items-center justify-center rounded-xl border border-neutral-200 bg-white text-neutral-700 transition hover:border-red-200 hover:bg-red-50 hover:text-red-500 lg:hidden"
                  >
                    {menuOpen ? (
                      <MdClose className="text-2xl" />
                    ) : (
                      <MdMenu className="text-2xl" />
                    )}
                  </button>
                </div>
      
                {/* Mobile Navigation */}
                {menuOpen && (
                  <div className="mt-3 overflow-hidden rounded-[22px] border border-neutral-100 bg-white p-4 shadow-[0_20px_60px_rgba(0,0,0,0.10)] lg:hidden">
                    <div className="grid gap-1">
                      <button
                        type="button"
                        onClick={() => scrollToSection("home")}
                        className="rounded-xl px-4 py-3 text-left text-sm font-bold text-neutral-700 transition hover:bg-red-50 hover:text-red-500"
                      >
                        Home
                      </button>
      
                      <button
                        type="button"
                        onClick={() => scrollToSection("benefits")}
                        className="rounded-xl px-4 py-3 text-left text-sm font-bold text-neutral-700 transition hover:bg-red-50 hover:text-red-500"
                      >
                        Benefits
                      </button>
      
                      <button
                        type="button"
                        onClick={() => scrollToSection("how-it-works")}
                        className="rounded-xl px-4 py-3 text-left text-sm font-bold text-neutral-700 transition hover:bg-red-50 hover:text-red-500"
                      >
                        How It Works
                      </button>
      
                      <button
                        type="button"
                        onClick={() => scrollToSection("support")}
                        className="rounded-xl px-4 py-3 text-left text-sm font-bold text-neutral-700 transition hover:bg-red-50 hover:text-red-500"
                      >
                        Support
                      </button>
                    </div>
      
                    <div className="mt-4 grid gap-3">
                      <button
                        type="button"
                        onClick={goLogin}
                        className="flex min-h-[54px] w-full cursor-pointer items-center justify-center gap-3 rounded-2xl border border-neutral-200 bg-white px-5 text-sm font-bold text-neutral-700 shadow-sm transition hover:border-red-200 hover:bg-red-50 hover:text-red-600 active:scale-[0.98]"
                      >
                        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-red-50 text-red-500">
                          <MdLogin />
                        </span>
      
                        Rider Login
                      </button>
      
                      <button
                        type="button"
                        onClick={goRegister}
                        className="flex min-h-[54px] w-full cursor-pointer items-center justify-center gap-3 rounded-2xl bg-red-500 px-5 text-sm font-black text-white shadow-[0_14px_30px_rgba(239,68,68,0.25)] transition hover:bg-red-600 active:scale-[0.98]"
                      >
                        Become a Rider
                        <FaArrowRight />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </header>
      
    </div>
  )
}

export default Headers